export default __webpack_public_path__ + "static/media/1097.1a3599a4.png";